// Dropdown chevron matching Figma "Icon / Basic / Dropdown Chevron Down".
// Used by the CRM classic (simplified) TierAiBlock, which renders a collapsible
// dropdown affordance rather than the WM fullscreen expand/minimize arrows.
import { jsx as _jsx } from "react/jsx-runtime";
const ChevronSvg = ()=>/*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4 6L8 10L12 6",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
export default ChevronSvg;
